import { useEffect, useState } from 'react';
import baseOnHandProducts from '../data/onHandProducts';

export default function useOnHandProducts() {
  const [onHand, setOnHand] = useState(baseOnHandProducts);

  useEffect(() => {
    // Optionally sync from localStorage or backend if needed
    const storedUpdates = JSON.parse(localStorage.getItem('onHandInventory') || '{}');
    if (Object.keys(storedUpdates).length) {
      const updated = baseOnHandProducts.map(p => {
        const newQty = storedUpdates[p.id] ?? p.inventory?.stockQty ?? 0;
        return {
          ...p,
          inventory: { ...p.inventory, stockQty: newQty },
        };
      });
      setOnHand(updated);
    }
  }, []);

  return onHand;
}
